import { Col, Row, Typography } from 'antd';
import { UserAccessLevelPlanEnum } from 'api/UsersApi';
import { useGetOneUserSysAdminQuery } from 'api/SysAdminApi';
import SysAdminLifeReviewResponseListComponent from 'components/SysAdmin/SysAdminLifeReviewResponseListComponent/SysAdminLifeReviewResponseListComponent';
import SysAdminMessageListComponent from 'components/SysAdmin/SysAdminMessageListComponent/SysAdminMessageListComponent';
import SysAdminPaymentListComponent from 'components/SysAdmin/SysAdminPaymentListComponent/SysAdminPaymentListComponent';
import SysAdminPreviewMessageModalComponent from 'components/SysAdmin/SysAdminPreviewMessageModalComponent/SysAdminPreviewMessageModalComponent';
import { getFullNameOrEmail } from 'utils/utils';
import './SysAdminUserDetailsComponent.css';

type AllProps = {
  userId: string;
};

function SysAdminUserDetailsComponent({ userId }: AllProps) {
  const { data: sysAdminUserData } = useGetOneUserSysAdminQuery({
    id: userId
  });

  const storedPlan = sysAdminUserData?.accessLevelPlan || 'N/A';
  const effectiveAccessLabel =
    sysAdminUserData?.isOrganizationSponsoredAccess &&
    sysAdminUserData?.effectiveAccessLevelPlan === UserAccessLevelPlanEnum.Unlimited
      ? 'Organization-sponsored Unlimited'
      : sysAdminUserData?.effectiveAccessLevelPlan || sysAdminUserData?.accessLevelPlan || 'N/A';

  const portalAccessLabel =
    sysAdminUserData?.portalAccessStatus === 'registered'
      ? 'Registered'
      : sysAdminUserData?.portalAccessStatus === 'invite_sent'
      ? 'Invite sent'
      : sysAdminUserData?.portalAccessStatus === 'profile_only'
      ? 'Profile only'
      : 'N/A';

  return (
    <>
      <div className="sys-admin-user-list-component">
        <Typography>
          <h2>{getFullNameOrEmail(sysAdminUserData)}</h2>
        </Typography>

        <Row gutter={[0, 10]}>
          <Col xs={12}>Email: {sysAdminUserData?.email || 'No email on file'}</Col>
          <Col xs={12}>Gender: {sysAdminUserData?.gender || 'N/A'}</Col>
          <Col xs={12}>Lifecycle Status: {sysAdminUserData?.status || 'N/A'}</Col>
          <Col xs={12}>Portal Access: {portalAccessLabel}</Col>
          <Col xs={12}>Stored plan: {storedPlan}</Col>
          <Col xs={12}>Effective access: {effectiveAccessLabel}</Col>
          <Col xs={12}>Total messages: {sysAdminUserData?.messagesCount || 0}</Col>
          <Col xs={12}>Completed messages: {sysAdminUserData?.messagesPublishedCount || 0}</Col>
        </Row>

        <SysAdminPaymentListComponent userId={userId} />
        <SysAdminMessageListComponent userId={userId} />
        <SysAdminLifeReviewResponseListComponent userId={userId} />
      </div>

      <SysAdminPreviewMessageModalComponent />
    </>
  );
}

export default SysAdminUserDetailsComponent;
